import React from 'react';
import RetrieveIndividualApplication from '../components/RetrieveIndividualApplication';

function RetrieveIndividualApplicationPage() {
    return <RetrieveIndividualApplication />;
}

export default RetrieveIndividualApplicationPage;